// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"39a5e44b","434":"185b3799","803":"c04effb2"}[chunkId] + ".chunk.css";
};